const routes = [{
  path: '/ultimate/report/cost',
  component: () => import('@/views/ultimate/report/cost'),
  name: 'ultimate-report-cost',
  meta: {
    title: '分支机构费用报表'
  }
}, {
  path: '/ultimate/report/performance',
  component: () => import('@/views/ultimate/report/performance'),
  name: 'ultimate-report-performance',
  meta: {
    title: '分支机构业绩报表'
  }
}, {
  path: '/ultimate/report/diurnal',
  component: () => import('@/views/ultimate/report/diurnal'),
  name: 'ultimate-report-diurnal',
  meta: {
    title: '日周月报表'
  }
}, {
  path: '/ultimate/report/regulation',
  component: () => import('@/views/ultimate/report/regulation'),
  name: 'ultimate-report-regulation',
  meta: {
    title: '分支机构监管报表'
  }
}, {
  path: '/ultimate/report/commission',
  component: () => import('@/views/ultimate/report/commission'),
  name: 'ultimate-report-commission',
  meta: {
    title: '业务员佣金汇总'
  }
}, {
  path: '/ultimate/report/standingbook',
  component: () => import('@/views/ultimate/report/standingBook'),
  name: 'ultimate-report-standing-book',
  meta: {
    title: '流水账'
  }
}, {
  path: '/ultimate/report/salesmanperformance',
  component: () => import('@/views/ultimate/report/salesmanPerformance'),
  name: 'ultimate-report-salesman-performance',
  meta: {
    title: '业务员业绩报表'
  }
}, {
  path: '/ultimate/report/organizationreport',
  component: () => import('@/views/ultimate/report/organizationReport'),
  name: 'ultimate-report-organization-report',
  meta: {
    title: '部门业绩汇总'
  }
}, {
  path: '/ultimate/report/outperformance',
  component: () => import('@/views/ultimate/report/outPerformance'),
  name: 'ultimate-report-out-performance',
  meta: {
    title: '出单员业绩报表'
  }
}, {
  path: '/ultimate/report/regulatory',
  component: () => import('@/views/ultimate/report/regulatory'),
  name: 'ultimate-report-regulatory',
  meta: {
    title: '监管报表'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/ultimate/report.js